import React from "react";

const KeyInformationLabel = ({ children, className }) => {
  return <label className={className}> {children} </label>;
};

export default KeyInformationLabel;
